import { useDebounce } from '@/common/hooks/debounce/useDebounce';
import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useEntityMgr } from '../entityView/EntityMgrContext';

export const SearchBox = () => {
  
  const { searchBoxQuery, setSearchBoxQuery} = useEntityMgr();

  // Local state for search box text
  const [searchBoxText, setSearchBoxText] = useState(searchBoxQuery); 
  
  const debounceValue = useDebounce(searchBoxText, 500);
  useEffect(() => {
    setSearchBoxQuery(searchBoxText);
  }, [debounceValue])

  return (
    <TextField 
      placeholder="Search..."
      size="small"
      variant="outlined"
      value={searchBoxText}
      onChange={(event) => setSearchBoxText(event.target.value)}
    />
  );
};
